import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCommentSolid = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 18,
	viewBox: "0 0 21 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.0001 0.25C12.797 0.25 14.4767 0.640625 16.0001 1.34375C17.5235 2.08594 18.7345 3.0625 19.6329 4.3125C20.5314 5.5625 21.0001 6.89062 21.0001 8.375C21.0001 9.85938 20.5314 11.2266 19.6329 12.4766C18.7345 13.7266 17.5235 14.7031 16.0001 15.4062C14.4767 16.1484 12.797 16.5 11.0001 16.5C9.51573 16.5 8.14854 16.2656 6.82042 15.7578C6.11729 16.3047 5.41417 16.7344 4.67198 17.0469C3.57823 17.5156 2.44542 17.75 1.3126 17.75C1.15635 17.75 1.07823 17.7109 1.03917 17.5547C0.961042 17.4375 1.0001 17.3203 1.07823 17.2031C1.3126 16.9688 1.58604 16.6172 1.97667 16.0703C2.60167 15.1719 2.99229 14.3125 3.22667 13.4922C2.52354 12.7891 1.97667 11.9688 1.58604 11.1094C1.19542 10.25 1.0001 9.35156 1.0001 8.375C1.0001 6.89062 1.42979 5.5625 2.32823 4.3125C3.22667 3.0625 4.4376 2.08594 5.96104 1.34375C7.48448 0.640625 9.16417 0.25 11.0001 0.25Z",
		fill: "currentColor"
	})
});
export default SvgCommentSolid;
